import * as React from "react";
import { CorrectionItemPreviewProps, CorrectionItemPreview } from "../WizardTypings";
import { CorrectionBreakdownItem } from "../../CorrectionBreakdownItem";
import { Correction } from "../../../Request/DcfRequestReducer";

const PreviewSelector = (corrections: Correction[]): boolean => corrections.length > 0 && corrections[0].entity == "CoughSession" && corrections[0].field == "IsSuppressed";

const SuppressCoughSessionPreviewItem = ({ corrections }: CorrectionItemPreviewProps): JSX.Element => {
    if (!(PreviewSelector(corrections))) {
        return null;
    }

    return <CorrectionBreakdownItem key={`BreakdownItem${name}`} fieldName={corrections[0].field} from={corrections[0].oldValue} to={corrections[0].newValue} />;
};

const SuppressCoughSessionPreview: CorrectionItemPreview = {
    previewElement: SuppressCoughSessionPreviewItem,
    previewSelector: PreviewSelector
};

export default SuppressCoughSessionPreview;
